import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { c as _ } from "./clsx-OuTLNxxd.js";
import { I as m } from "./icon-BnqXyiyH.js";
import "./components/elements/icon/iconsList.js";
const u = "_callout_5p9zs_29", p = "_link_5p9zs_49", o = {
  callout: u,
  "is-small": "_is-small_5p9zs_44",
  link: p,
  "is-medium": "_is-medium_5p9zs_52",
  "is-info": "_is-info_5p9zs_55",
  "is-warning": "_is-warning_5p9zs_58",
  "is-success": "_is-success_5p9zs_61",
  "is-error": "_is-error_5p9zs_64",
  "is-neutral": "_is-neutral_5p9zs_67",
  "is-collection": "_is-collection_5p9zs_70",
  "content-container": "_content-container_5p9zs_76",
  "dialog-overlay-show": "_dialog-overlay-show_5p9zs_1",
  "dialog-content-show": "_dialog-content-show_5p9zs_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_5p9zs_1"
}, c = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, d = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, f = {
  small: "is-small",
  medium: "is-medium"
};
function h({
  status: s = "info",
  size: l = "medium",
  children: r,
  hasIcon: e = !1,
  backgroundImage: n
}) {
  const a = _(o.callout, o[d[s]], o[f[l]]);
  return /* @__PURE__ */ t("div", { className: a, children: [
    e && /* @__PURE__ */ i(m, { name: c[s].name, color: c[s].color, size: "2xl" }),
    /* @__PURE__ */ i("div", { className: o["content-container"], children: r }),
    n && /* @__PURE__ */ i("img", { src: n, alt: "background" })
  ] });
}
export {
  h as C,
  c as I,
  d as a,
  f as b
};
